import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=48c49c8e&"
var script = {}
import style0 from "./lists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports